var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"w-full form-control form-input form-input-bordered form-input--small",attrs:{"type":"text","placeholder":_vm.$t('Enter number')},domProps:{"value":_vm.item.response},on:{"change":_vm.handleChange,"keyup":_vm.handleChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }